import { CustomPage } from "../../DashboardApp/types";

// @ts-ignore
import FlashSale from "./pages/FlashSale";
import AddProducts from "./pages/AddProducts";

export const customPages = [
	{ moduleId: "31734344-7fb8-4e83-8311-05220059b719", path: "list", content: <FlashSale /> },
	{ moduleId: "31734344-7fb8-4e83-8311-05220059b719", path: "add-product/:id", content: <AddProducts /> },
] as CustomPage[];
